import { render, staticRenderFns } from "./DetailsList.vue?vue&type=template&id=4478315a&scoped=true"
import script from "./DetailsList.vue?vue&type=script&lang=js"
export * from "./DetailsList.vue?vue&type=script&lang=js"
import style0 from "./DetailsList.vue?vue&type=style&index=0&id=4478315a&prod&scoped=scoped&lang=css"
import style1 from "./DetailsList.vue?vue&type=style&index=1&id=4478315a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478315a",
  null
  
)

export default component.exports